define(['edge/platform/base/BaseCtrl', 'underscore'], (BaseCtrl, _)=> {
    const fn = function ($scope, StateUtils) {
        const ctrl = Object.create(BaseCtrl);
        const flowModel = StateUtils.activeDataForState(true).flowModel;

        /**
         * Method used by wizard ribbon set styles for active and visited steps in the wizard flow
         */
        function refreshStepsFn() {
            function setStepClasses(wizardSteps) {
                
                if (wizardSteps.length > 0) {
                    const currentStateIdx = _.findIndex(wizardSteps, (step) => step.name === flowModel.currentStep.name);

                    
                    for (let stepIdx = 0; stepIdx < wizardSteps.length; stepIdx++) {
                        const step = wizardSteps[stepIdx];
                        const visited = stepIdx <= currentStateIdx;
                       
                        if (currentStateIdx != -1 && ctrl.getVisibleStatus(wizardSteps[currentStateIdx].name)==true){
                        const activeClass = currentStateIdx === stepIdx ? 'gw-current' : '';
                        const notVisitedClass = (visited || stepIdx === 0) ? '' : 'gw-not-visited';
                        const visitedClass = (visited && currentStateIdx === stepIdx) ? 'gw-visited' : '';
                        const allowedVisitClass = flowModel.isStepAccessibleFromCurrent(step) ? 'gw-allowed' : 'gw-not-allowed';
                        step.styleClass = `${activeClass} ${notVisitedClass} ${visitedClass} ${allowedVisitClass}`;
                    }
                    }
                }
            }
            $scope.wizardSteps.length = 0;
            Array.prototype.push.apply($scope.wizardSteps, flowModel.steps);
            $scope.ribbonVisible = $scope.wizardSteps.length > 0;
            setStepClasses($scope.wizardSteps);
            //console.log("wizardsteps  ", $scope.wizardSteps);
        }

        ctrl.init = function () {
            if (!flowModel) {
                return;
            }
            $scope.wizardSteps = [];
            $scope.ribbonVisible = false;
            //console.log("scope: ", $scope.$root.submission.draftData);
            $scope.ignoreStates = [];
            // If product code is home owners then skip to display the following states
            if( $scope.$root.submission.draftData.productCode === "Homeowners"){
                $scope.ignoreStates = ["hoPrequalQuestions", "hoMembership", "hoYourHome", "hoConstruction", "hoPolicyInfo", "paymentDetails", "nextSteps"];
            }

            else if($scope.$root.submission.draftData.productCode == "PersonalAuto" ){
                $scope.ignoreStates = ["paPrequalQuestions", "paMembership","paPrevCarrierInfo" ,"paDriverVehiclePrefillInfo", "paPolicySummary", "paymentConfirmation" ];
            }
            refreshStepsFn();
            

            flowModel.addStepChangeListener(refreshStepsFn);

            $scope.$on('$destroy', ()=> {
                flowModel.removeStepChangeListener(refreshStepsFn);
            });
        };


        ctrl.getVisibleStatus = function(stateName){
            
            return ($scope.ignoreStates.indexOf(stateName)==-1)
        }
        /**
         * Method used by wizard ribbon to move between steps.
         * @param {Object} step - selected step
         */
        ctrl.selectStep = function (step) {
            const currentModel = StateUtils.activeDataForState(true).model;
            if (flowModel.isStepAccessibleFromCurrent(step)) {
                flowModel.jumpToStep(step, currentModel);
            }
        };

        ctrl.stepLabel = function (step) {
            return step.label();
        };

        return ctrl.create($scope);
    };
    fn.$inject = ['$scope', 'StateUtils'];

    return fn;
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/widgets/wizard/_WizardStepsCtrl.js
 **/